/* ==========================================================================
  Bb cross Game Constants
========================================================================== */
export const MIN_MINE_COUNT = 1
export const MAX_MINE_COUNT = 10
export const MIN_TILE_COUNT = 1
export const MAX_TILE_COUNT = 24
export const DEFAULT_MINE_COUNT = 3
export const DEFAULT_MINE_GAME_AUTOBET_ROUNDS = '∞'

export const DEFAULT_DIFFICULTY_VALUE = 1

export const LANE_MINE_TILE_COUNT =  { 1: 25, 2: 22, 3: 20, 4: 15 }

export const LANE_MINE_COUNT = { 1: 1, 2: 3, 3: 4, 4: 8 }

export const LANE_MINE_FIXED_ODDS = {
  1: [1, 1.04, 1.09, 1.12, 1.16, 1.21, 1.27, 1.35, 1.43, 1.51, 1.70, 1.77, 1.90, 2.08, 2.26, 2.45, 2.88, 3.05, 3.34, 3.60, 5.07, 5.80, 9.00, 17, 24],
  2: [1.09, 1.25, 1.48, 1.75, 2.01, 2.48, 2.91, 3.47, 3.14, 4.99, 6.07, 7.88, 10.24, 14.38, 19.40, 27.29, 39.43, 63.09, 110.40, 220.80, 552, 2208],
  3: [1.20, 1.35, 1.50, 2.30, 2.95, 4.05, 5.19, 7.01, 9.20, 13.00, 19.14, 28.23, 48.40, 87.40, 119.40, 280.80, 500.80, 1430.80, 4500.80, 25004.80],
  4: [1.60, 2.74, 7.85, 13.90, 22.98, 40.97, 78.71, 161.35, 391.86, 1044.96, 3134.87, 10972.06, 47545.60, 285273.60, 3138009.60]
}

export const TABS = {
  ALL_BETS: 'ALL_BETS',
  TOP_BETS: 'TOP_BETS'
}
